import React from 'react';
import type { FC } from 'react';
import { Text } from '@wix/cli-ui-kit';

export const Unauthenticated: FC = () => {
  return (
    <Text>
      You are not authenticated, log in by running{' '}
      <Text skin="info">wix login</Text>
    </Text>
  );
};
